import { lazy, Suspense, useEffect, useState } from 'react'
import UberEatsBanner from './UberEatsBanner'
import UberEatsHelp from './UberEatsHelp'

const ShuttleAppreciation = lazy(() => import('../../shuttle_software/ShuttleAppreciation'));
const TaxiFaq = lazy(() => import('../../taxiDispatchSoftware/TaxiFaq'));
const GroceryMarket = lazy(() => import('../groceryApp/GroceryMarket'));
const UberEatsAdvance = lazy(() => import('./UberEatsAdvance'));
const UberEatsBenifits = lazy(() => import('./UberEatsBenifits'));
const UberEatsDemand = lazy(() => import('./UberEatsDemand'));
const UberEatsLove = lazy(() => import('./UberEatsLove'));
const UberEatsOffer = lazy(() => import('./UberEatsOffer'));
const UberEatsPower = lazy(() => import('./UberEatsPower'));
const UberEatsProcess = lazy(() => import('./UberEatsProcess'));
const UberEatsRevenue = lazy(() => import('./UberEatsRevenue'));
const UberEatsScript = lazy(() => import('./UberEatsScript'));
const UberEatsSteps = lazy(() => import('./UberEatsSteps'));
const UberEatsUnique = lazy(() => import('./UberEatsUnique'));

const bannerData = {
  heading: "UberEats Clone App AI-powered",
  desc: "Our AI-powered UberEats clone app delivers a seamless, fast, and personalized food ordering experience, connecting restaurants and customers efficiently.",
  cta: "Get free demo",
  image: "/assets/home/uber-eats-banner.webp",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "UberEats Clone App",
        slug: ""
      },
    ]
  }
}

const helpData = {
  headingPart1: "What Is an",
  headingPart2: "UberEats Clone",
  headingPart3: "& How Does It Help?",
  desc: [
    "An UberEats clone is a ready-made food delivery app solution that mirrors the key features and functionality of the UberEats platform. It comes complete with customer ordering interfaces, restaurant dashboards, driver management tools, and admin panels. Fully customizable, these clones allow businesses to add their branding, unique features, and local preferences, saving months of development time and significant costs.",

    "Such solutions enable entrepreneurs and food delivery startups to enter the market swiftly, bypassing the complexities of building an app from scratch. With a pre-built UberEats clone by Mobility Infotech, businesses can launch their platforms in days, allowing them to focus on branding, customer engagement, and forming strategic partnerships."
  ]
}

const processData = {
  headingPart1: "How",
  headingPart2: "AI-Fueled UberEATS",
  headingPart3: "like app Streamlines Process?",
  subHeading: "An AI-powered UberEats-like app by Mobility Infotech enhances food delivery operations by automating orders, optimizing delivery routes, reducing delays, and boosting customer satisfaction through real-time, data-driven decision-making.",
  boxes: [
    {
      image1: "/assets/home/uber-eats-process-1.webp",
      image2: "/assets/home/uber-eats-process-hover-1.webp",
      head: "AI Personalisation Engine",
      desc: "The AI-driven personalization engine uses machine learning and NLP to understand user preferences, automate routine tasks, and deliver proactive recommendations. This ensures a highly personalized experience, improving engagement.",
    },
    {
      image1: "/assets/home/uber-eats-process-2.webp",
      image2: "/assets/home/uber-eats-process-hover-2.webp",
      head: "AI-Aided Virtual Assistant",
      desc: "The AI virtual assistant helps manage customer queries, track orders, and provide instant support. By automating repetitive tasks and offering smart suggestions, it makes operations faster, smoother, and more intuitive.",
    },
    {
      image1: "/assets/home/uber-eats-process-3.webp",
      image2: "/assets/home/uber-eats-process-hover-3.webp",
      head: "AI-Centric Dynamic Pricing",
      desc: "With AI-centric dynamic pricing, the app analyzes demand, time, and location to adjust prices intelligently. This maximizes revenue, ensures competitive pricing, and enhances overall process and operational efficiency.",
    },
  ]
}

const benifitData = {
  label: "AI-ENABLED Benefits In",
  headingPart1: "Encounter",
  headingPart2: "The Advantages of",
  headingPart3: "UberEats Clone App",
  subHeading: "Stand out in food delivery with exclusive AI features from Mobility Infotech that boost efficiency, personalize experiences, and drive faster business growth.",
  allTabs: [
    {
      name: "Eater",
      data: [
        {
          image: "/assets/home/uber-eats-eater-1.webp",
          mainImage: "/assets/home/uber-eats-eater-main1.webp",
          title: "Takeaway Option",
          desc: "Order food for takeaway effortlessly with AI-recommended pickup times and favorite dishes.",
        },
        {
          image: "/assets/home/uber-eats-eater-2.webp",
          mainImage: "/assets/home/uber-eats-eater-main2.webp",
          title: "Support Option",
          desc: "AI-powered support provides instant answers and real-time query resolution.",
        },
        {
          image: "/assets/home/uber-eats-eater-3.webp",
          mainImage: "/assets/home/uber-eats-eater-main3.webp",
          title: "Tips Option",
          desc: "Add tips easily, with AI suggesting fair amounts based on past orders.",
        },
        {
          image: "/assets/home/uber-eats-eater-4.webp",
          mainImage: "/assets/home/uber-eats-eater-main4.webp",
          title: "Payment Gateway",
          desc: "Enjoy secure, fast transactions with AI detecting and blocking anomalies.",
        },
        {
          image: "/assets/home/uber-eats-eater-5.webp",
          mainImage: "/assets/home/uber-eats-eater-main5.webp",
          title: "Profile Management",
          desc: "AI saves preferences, history, and special requests for a personalized experience.",
        },
      ],
    },
    {
      name: "restaurant Owner",
      data: [
        {
          image: "/assets/home/uber-eats-eater-1.webp",
          mainImage: "/assets/home/uber-eats-restaurant-main1.webp",
          title: "Takeaway Option",
          desc: "Boost orders with AI-backed suggestions for trending takeaway dishes and pricing.",
        },
        {
          image: "/assets/home/uber-eats-eater-2.webp",
          mainImage: "/assets/home/uber-eats-restaurant-main2.webp",
          title: "Profile Management",
          desc: "AI analyzes customer insights, reviews, and preferences to refine offerings.",
        },
        {
          image: "/assets/home/uber-eats-eater-3.webp",
          mainImage: "/assets/home/uber-eats-restaurant-main3.webp",
          title: "Multiple Language",
          desc: "AI-driven translations make menus accessible to diverse audiences seamlessly.",
        },
      ],
    },
    {
      name: "DELIVERY PROVIDER",
      data: [
        {
          image: "/assets/home/uber-eats-eater-1.webp",
          mainImage: "/assets/home/uber-eats-delivery-main1.webp",
          title: "Single Pickup/Multiple Delivery Option",
          desc: "AI optimizes grouped deliveries for speed, fuel savings, and higher efficiency.",
        },
        {
          image: "/assets/home/uber-eats-eater-2.webp",
          mainImage: "/assets/home/uber-eats-delivery-main2.webp",
          title: "Tips Option",
          desc: "Receive tips effortlessly with AI recommendations that encourage fair rewards.",
        },
        {
          image: "/assets/home/uber-eats-eater-3.webp",
          mainImage: "/assets/home/uber-eats-delivery-main3.webp",
          title: "Profile Management",
          desc: "AI-powered profiles track performance, earnings, and ratings for improvement.",
        },
        {
          image: "/assets/home/uber-eats-eater-4.webp",
          mainImage: "/assets/home/uber-eats-delivery-main4.webp",
          title: "Multiple Language",
          desc: "Multi-language support ensures clear communication across regions and customers.",
        },
        {
          image: "/assets/home/uber-eats-eater-5.webp",
          mainImage: "/assets/home/uber-eats-delivery-main5.webp",
          title: "Navigation Option",
          desc: " AI provides the fastest, real-time optimized routes for on-time delivery.",
        },
      ],
    },
    {
      name: "ADMIN",
      data: [
        {
          image: "/assets/home/uber-eats-eater-1.webp",
          mainImage: "/assets/home/uber-eats-admin-main1.webp",
          title: "Separate Eaters, Drivers, Restaurant Management",
          desc: "AI simplifies managing all user groups with clarity and efficiency.",
        },
        {
          image: "/assets/home/uber-eats-eater-2.webp",
          mainImage: "/assets/home/uber-eats-admin-main2.webp",
          title: "Single Pickup/Multiple Delivery Option",
          desc: "AI enhances logistics by monitoring and optimizing bulk deliveries.",
        },
        {
          image: "/assets/home/uber-eats-eater-3.webp",
          mainImage: "/assets/home/uber-eats-admin-main3.webp",
          title: "Support Option",
          desc: "AI chat support resolves queries instantly for smooth operations.",
        },
        {
          image: "/assets/home/uber-eats-eater-4.webp",
          mainImage: "/assets/home/uber-eats-admin-main4.webp",
          title: "Admin Management & Roles",
          desc: "Easily assign roles and manage admins with AI-driven insights.",
        },
        {
          image: "/assets/home/uber-eats-eater-5.webp",
          mainImage: "/assets/home/uber-eats-admin-main5.webp",
          title: "Easy Driver Document Management",
          desc: "AI validates and manages driver documents for compliance and quick onboarding.",
        },
      ],
    }
  ]

}

const stepData = {
  headingPart1: "Step-By-Step Order Flow",
  headingPart2: "In A UberEats Clone App",
  subHeading: "Explore the complete order flow of a UberEats clone app, from browsing restaurants to doorstep delivery.",
  image: "",
}

const forYouData = {
  newClass: "uber-eats-for-you",
  text1: "$50 Billion+ Market",
  text2: "Opportunity",
  des: "On-demand grocery delivery apps are rapidly capturing global market share and consumer demand.",
  btn: "Build Your App",
}

const scriptData = {
  titlePart1: "Best",
  titlePart2: "Food Delivery Scripts",
  titlePart3: "to Launch Your On-Demand App",
  description: "Launch your own food delivery business with these top-rated food delivery scripts inspired by global brands.",
}

const demandData = {
  image: "/assets/home/uber-eats-demand.webp",
  titlePart1: "Lead the",
  titlePart2: "On-Demand Food",
  titlePart3: "Delivery World",
  desc: "Stay ahead in the rapidly growing food delivery market with the Mobility Infotech UberEats Clone Script. Whether you’re leveraging a proven business model or launching a unique concept, our solution enables you to scale quickly and efficiently. With robust features, a seamless user experience, and full customization options, you can launch your platform fast while staying competitive in today’s digital-first landscape.",
  desc2: "Our clone script by Mobility Infotech offers real-time order tracking, multi-payment integrations, and geo-based restaurant listings, ensuring enhanced customer satisfaction and streamlined operational efficiency.",
  cta: "Schedule a meeting"
}

const RevenueData = {
  titlePart1: "How",
  titlePart2: "UberEats Clone Apps",
  titlePart3: "Are Making Revenue?",
  desc: "Ultimate Earning Sources Of Our UberEats Clone Script",
  boxes: [
    {
      image: "/assets/home/eats-revenue-1.webp",
      heading: "Commission Fee",
      description: "Earn revenue on every order placed through your platform. Apply service fees to both customers and restaurant partners seamlessly.",
    },
    {
      image: "/assets/home/eats-revenue-2.webp",
      heading: "Dynamic Surge Pricing",
      description: "Boost earnings with AI-powered surge pricing. Adjust rates in real time based on demand, location, and delivery availability.",
    },
    {
      image: "/assets/home/eats-revenue-3.webp",
      heading: "Referral Earnings",
      description: "Grow your user base with referral rewards. Encourage customers to invite friends, ensuring steady revenue from new users.",
    },
    {
      image: "/assets/home/eats-revenue-4.webp",
      heading: "Showcase The Sponsors",
      description: "Offer sponsored restaurant listings for premium visibility. Charge a fee to boost restaurants’ reach and attract more customers.",
    },
    {
      image: "/assets/home/eats-revenue-5.webp",
      heading: "Flexible Commissions",
      description: "Set variable commission rates based on order volumes, demand, or restaurant popularity—aligning perfectly with your unique business goals.",
    },
  ]
}

const uniqueData = {
  titlePart1: "What Makes Us",
  titlePart2: "Unique?",
  desc: "Discover the features, innovations, and unmatched value that make the Mobility Infotech UberEats Clone Script the smart choice for your business.",
  boxes: [
    {
      image: "/assets/home/uber-eats-unique-1.webp",
      heading: "Free Server Installation",
      description: "We install the UberEats Clone Script on your server free of cost, making your platform live quickly and effortlessly.",
    },
    {
      image: "/assets/home/uber-eats-unique-2.webp",
      heading: "Free App Submission",
      description: "Our team provides complete support in submitting your apps to the iOS App Store and Google Play Store successfully.",
    },
    {
      image: "/assets/home/uber-eats-unique-1.webp",
      heading: "Free Bug Support",
      description: "Get instant free support for any critical bugs during the support period included in your purchased package.",
    },
    {
      image: "/assets/home/uber-eats-unique-4.webp",
      heading: "On-Time Support",
      description: "Our dedicated team ensures timely assistance across multiple communication channels, providing reliable support.",
    },
    {
      image: "/assets/home/uber-eats-unique-5.webp",
      heading: "100% Source Code",
      description: "Depending on your package, you receive full source code access, allowing you to edit, customize, and scale your app.",
    },
    {
      image: "/assets/home/uber-eats-unique-6.webp",
      heading: "Native IOS & Android Apps",
      description: "Expertly crafted in native languages, our apps ensure smooth compatibility across both iOS and Android platforms.",
    },
    {
      image: "/assets/home/uber-eats-unique-7.webp",
      heading: "Support After App Rejection",
      description: "We stand by you even after purchase, offering support if your app faces rejection during submission.",
    },
    {
      image: "/assets/home/uber-eats-unique-8.webp",
      heading: "Free Technical Support",
      description: "Our team assists with third-party integrations, including SMS gateways, servers, and more—free of cost.",
    },
    {
      image: "/assets/home/uber-eats-unique-9.webp",
      heading: "Free White Labeling",
      description: "Promote your brand effortlessly—replace our branding with your logo and company name across the entire platform.",
    },
  ]
}

const loveData = {
  titlePart1: "Unique Features",
  titlePart2: "You’ll Love",
  desc: "Explore the powerful, user-focused features that make the Mobility Infotech platform stand out. Designed for performance, scalability, and ease of use, each function is built to elevate your food delivery business.",
  boxes: [
    {
      image: "/assets/home/uber-eats-love-1.webp",
      heading: "Admin Management & Roles",
      description: "Easily manage all business activities from a single platform. Assign roles, monitor actions, and streamline precess effortlessly.",
    },
    {
      image: "/assets/home/uber-eats-love-2.webp",
      heading: "Unique Dashboards",
      description: "Dedicated dashboards for Eaters, Delivery Partners, and Restaurants provide clear visibility over the entire workflow.",
    },
    {
      image: "/assets/home/uber-eats-love-3.webp",
      heading: "Easy Driver Documentation",
      description: "Verify delivery partner documents quickly to prevent fraud and ensure trust. Approvals are fast, secure, and essential for reliability.",
    },
    {
      image: "/assets/home/uber-eats-love-4.webp",
      heading: "Live Tracking",
      description: "Monitor every move of delivery partners—from restaurant pickup to doorstep delivery—with precise, real-time GPS tracking.",
    },
    {
      image: "/assets/home/uber-eats-love-5.webp",
      heading: "Review Management",
      description: "Admins can manage user-reported issues, edit or add categories, and export data for better monitoring and service improvement.",
    },
    {
      image: "/assets/home/uber-eats-love-6.webp",
      heading: "Reports",
      description: "Generate detailed reports across Eater, Driver, and Restaurant panels. Export in CSV or Excel for easy analysis and planning.",
    },
    {
      image: "/assets/home/uber-eats-love-7.webp",
      heading: "Geo-Location Search",
      description: "Enable users to quickly find exact destinations with geo-location search, ensuring accurate deliveries.",
    },
    {
      image: "/assets/home/uber-eats-love-8.webp",
      heading: "Real-Time Currency Rates",
      description: "Offer global convenience with automatic currency conversion, giving users accurate and seamless pricing in local currency.",
    },
    {
      image: "/assets/home/uber-eats-love-9.webp",
      heading: "Quick Business Launch",
      description: "Launch your food delivery business swiftly and confidently with the ready-to-deploy and smart solutions from Mobility Infotech.",
    },
  ]
}

const forYouTwoData = {
  newClass: "uber-eats-for-you-two",
  text1: "Leaders in Food",
  text2: "Delivery Innovation",
  des: "Innovative food delivery solutions designed for seamless experiences, business growth, and long-term market success.",
  btn: "Build Your App",
}

const powerData = {
  titlePart1: "Power Up with",
  titlePart2: "Add-Ons",
  desc: "Scale your revenue and food orders with our advanced add-ons designed to expand functionality, improve efficiency, and deliver better user experiences.",
  boxes: [
    {
      image: "/assets/home/uber-eats-power-1.webp",
      heading: "Multiple Language",
      description: "Break barriers by offering multiple language options, making it easier for users and partners to interact.",
    },
    {
      image: "/assets/home/uber-eats-power-2.webp",
      heading: "RTL Support",
      description: "Expand globally with RTL layout and Arabic translations, ensuring smooth usability for customers in Middle Eastern markets.",
    },
    {
      image: "/assets/home/uber-eats-power-3.webp",
      heading: "Modifiers",
      description: "Enable restaurant owners to dynamically add, edit, and manage detailed recipe information.",
    },
    {
      image: "/assets/home/uber-eats-power-4.webp",
      heading: "ChatGPT",
      description: "Enhance support with ChatGPT—automating responses, resolving customer queries instantly, and boosting engagement.",
    },
    {
      image: "/assets/home/uber-eats-power-5.webp",
      heading: "Algolia Search",
      description: "Deliver lightning-fast search results with Algolia, helping users easily find restaurants, cuisines, and dishes without hassle.",
    },
    {
      image: "/assets/home/uber-eats-power-6.webp",
      heading: "Crypto Wallet",
      description: "Empower digital-first customers with secure cryptocurrency payments via GoferEats Crypto Wallet, offering fast transactions.",
    },
    {
      image: "/assets/home/uber-eats-power-7.webp",
      heading: "Kiosk",
      description: "Simplify in-store operations with self-service kiosks, allowing customers to place orders without staff involvement.",
    },
    {
      image: "/assets/home/uber-eats-power-8.webp",
      heading: "Sunmi Integration",
      description: "Streamline order processing with SUNMI, offering smooth receipt printing for kitchens, deliveries, and customer takeaways.",
    },
    {
      image: "/assets/home/uber-eats-power-9.webp",
      heading: "Local Pay Gateway",
      description: "Support region-specific payment gateways, ensuring smooth and secure transactions tailored to local user preferences.",
    },
    {
      image: "/assets/home/uber-eats-power-10.webp",
      heading: "Other Maps",
      description: "Enhance delivery accuracy with support for Mapbox and TomTom, providing alternatives beyond Google Maps.",
    },
    {
      image: "/assets/home/uber-eats-power-11.webp",
      heading: "Local SMS Gateway",
      description: "Strengthen account security with local SMS verification, delivering codes directly to users’ devices for safer sign-ins.",
    },
    {
      image: "/assets/home/uber-eats-power-12.webp",
      heading: "External DB Backup",
      description: "Protect your business data with secure external database backups, ensuring safety against loss or unexpected failures.",
    },
    {
      image: "/assets/home/uber-eats-power-13.webp",
      heading: "Driver Subscription",
      description: "Offer driver subscriptions that reduce commissions, increase loyalty, and generate additional revenue for admins.",
    },
    {
      image: "/assets/home/uber-eats-power-14.webp",
      heading: "Driver Wallet",
      description: "Let delivery providers maintain a wallet balance while admins deduct dues for cash-based booking requests.",
    },
    {
      image: "/assets/home/uber-eats-power-15.webp",
      heading: "Store own driver",
      description: "Allow restaurants to use their own staff for deliveries, giving them more flexibility and independence.",
    },
    {
      image: "/assets/home/uber-eats-power-16.webp",
      heading: "Bidding System",
      description: "Enable delivery partners to bid on orders, balancing pricing, reducing wait times, and ensuring efficient service.",
    },
  ]
}

const advanceData = {
  titlePart1: "Advance",
  titlePart2: "Add-Ons",
  desc: "Supercharge your food delivery platform with advanced add-ons from Mobility Infotech. Each feature is designed to enhance functionality, simplify operations, and deliver tailored solutions that help your business scale faster, improve user experience, and stay ahead in a competitive market.",
  boxes: [
    {
      image: "/assets/home/uber-eats-advance-1.webp",
      backImage: "/assets/home/uber-eats-advance-back1.webp",
      heading: "ChatBots",
      description: "Upgrade customer support with AI-driven chatbots. Handle queries instantly, suggest listings, and deliver quick, accurate responses during live chat.",
    },
    {
      image: "/assets/home/uber-eats-advance-2.webp",
      backImage: "/assets/home/uber-eats-advance-back2.webp",
      heading: "Push Alerts",
      description: "Boost customer engagement with real-time AI-powered push alerts. Send personalized updates on orders, offers, and new restaurant launches instantly.",
    },
    {
      image: "/assets/home/uber-eats-advance-3.webp",
      backImage: "/assets/home/uber-eats-advance-back3.webp",
      heading: "Optimised Bookings",
      description: "Redefine scheduling with AI-predictive insights. Analyze trends and historical data to forecast peak demand and improve booking efficiency.",
    },
  ]
}

const offerData = {
  label: "Our Offerings",
  headingPart1: "What Do",
  headingPart2: "We Offer?",
  headingPart3: "",
  subHeading: "We at Mobility Infotech provide powerful, intuitive user panels crafted to streamline operations, enhance customer experiences, and ensure seamless management across customers, restaurants, and delivery partners—all within one unified ecosystem.",
  allTabs: [
    {
      name: "Eaters",
      boxes: [
        {
          image: "/assets/home/uber-eats-offer-1.webp",
          heading: "Eaters Android",
          description: "Allows the eaters to search and find their favorite restaurants and dishes in any location. This panel also has the option to show their profile in an impressive manner.",
        },
        {
          image: "/assets/home/uber-eats-offer-2.webp",
          heading: "Eaters  iOS",
          description: "Allows the eaters to search and find their favorite restaurants and dishes in any location. This panel also has the option to show their profile in an impressive manner.",
        },
        {
          image: "/assets/home/uber-eats-offer-3.webp",
          heading: "Eaters Web panel",
          description: "Allows the eaters to search and find their favorite restaurants and dishes in any location. This panel also has the option to show their profile in an impressive manner.",
        },
      ]
    },
    {
      name: "restaurant",
      boxes: [
        {
          image: "/assets/home/uber-eats-offer-1.webp",
          heading: "Restaurant Owner Android",
          description: "Your go-to Android app for smart, seamless, and convenient online service bookings.",
        },
        {
          image: "/assets/home/uber-eats-offer-2.webp",
          heading: "Restaurant Owner  iOS",
          description: "A dynamic iOS app designed to simplify, tailor, and enhance online service bookings.",
        },
        {
          image: "/assets/home/uber-eats-offer-3.webp",
          heading: "Restaurant Owner Web panel",
          description: "A powerful web panel to manage menus, orders, and monitor earnings with ease.",
        },
      ]
    },
    {
      name: "provider",
      boxes: [
        {
          image: "/assets/home/uber-eats-offer-1.webp",
          heading: "provider Android",
          description: "Your go-to Android app for smart, fast, and convenient online service bookings.",
        },
        {
          image: "/assets/home/uber-eats-offer-2.webp",
          heading: "provider  iOS",
          description: "A dynamic iOS app designed to tailor and enhance the online booking experience.",
        },
        {
          image: "/assets/home/uber-eats-offer-3.webp",
          heading: "provider Web panel",
          description: "An intuitive web panel to manage services, bookings, and monitor earnings effortlessly.",
        },
      ]
    },
    {
      name: "Admin",
      boxes: [
        {
          image: "/assets/home/uber-eats-offer-3.webp",
          heading: "Admin Web panel",
          description: "A powerful dashboard that lets admins manage users, monitor operations, track revenue, and ensure smooth platform performance.",
        },
      ]
    },

  ]
}

const faqData = [
  {
    id: "0",
    question: "01. What is an UberEats Clone app by Mobility Infotech?",
    answer: "An UberEats Clone app by Mobility Infotech is a ready-made food delivery solution that mirrors UberEats’ features but is fully customizable with your branding, features, and market preferences. It allows you to launch your food delivery business faster and more cost-effectively.",
  },
  {
    id: "1",
    question: "02. How long does it take to launch a food delivery app with Mobility Infotech’s UberEats Clone Script?",
    answer: "Unlike building from scratch, our clone script enables businesses to launch in just a few days. With free server setup, app submission, and white labeling, you can go live quickly without long development delays.",
  },
  {
    id: "2",
    question: "03. Is the UberEats Clone app customizable? ",
    answer: " Yes, our solution is 100% customizable. You can modify design, branding, features, and integrations according to your business model, target audience, and regional needs.",
  },
  {
    id: "3",
    question: "04. How does AI improve my food delivery business?",
    answer: "AI boosts efficiency through real-time route optimization, dynamic pricing, personalized recommendations, automated customer support, and predictive analytics—helping you improve customer satisfaction and increase revenue.",
  },
  {
    id: "4",
    question: "05. Do I get the full source code? ",
    answer: " Yes. Depending on your package, Mobility Infotech provides 100% source code access so you can edit, customize, and scale your app as your business grows.",
  },
  {
    id: "5",
    question: "06. What platforms are supported?",
    answer: " We provide native Android and iOS apps for eaters, restaurants, and delivery partners, along with powerful web panels and a robust admin dashboard for seamless management.",
  },

  {
    id: "6",
    question: "07. How does the revenue model work for an UberEats Clone app? ",
    answer: " You can earn from multiple sources including commissions on orders, dynamic surge pricing, referral programs, sponsored listings, and flexible commission structures. Our system is designed to maximize profitability.",
  },
];

export default function UberEats() {
  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsScroll(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <UberEatsBanner data={bannerData} />
      <UberEatsHelp data={helpData} />

      <Suspense fallback={null}>
        <UberEatsProcess data={processData} />
        {isScroll && (
          <>
            <UberEatsBenifits data={benifitData} />
            <UberEatsSteps data={stepData} />
            <GroceryMarket data={forYouData} />
            <UberEatsScript data={scriptData} />
            <UberEatsDemand data={demandData} />
            <UberEatsRevenue data={RevenueData} />
            <UberEatsUnique data={uniqueData} />
            <UberEatsLove data={loveData} />
            <GroceryMarket data={forYouTwoData} />
            <UberEatsPower data={powerData} />
            <UberEatsAdvance data={advanceData} />
            <UberEatsOffer data={offerData} />
            <ShuttleAppreciation />
            <div className="zip-faq-fixer">
              <TaxiFaq faqData={faqData} />
            </div>
          </>
        )}
      </Suspense>
    </>
  )
}
